import { MouseEventHandler } from 'react';
import { twMerge } from 'tailwind-merge';
import { SearchFacet } from '#server/models';
import { Button } from '@/components';

export interface SearchTabProps {
  index: number;
  to: string;
  label: string;
  onClick?: MouseEventHandler;
  value: SearchFacet;
  isSelected?: boolean;
  isResultsPageMode?: boolean;
  hidden?: boolean;
  facetCount?: number | null;
}

export const SearchTab = (props: SearchTabProps) => {
  return (
    <Button
      size="rounded"
      to={props.to}
      variant={props.isSelected ? 'filled-primary' : 'outline-primary'}
      onClick={props.onClick}
      className={twMerge(
        `after:contents-[''] before:contents-[''] relative bg-white transition-all duration-300 ease-in-out before:absolute
        before:-bottom-5 before:h-0 before:w-full before:bg-transparent before:transition-all before:duration-300
        before:ease-in-out after:absolute after:-inset-1 after:h-[calc(100%_+_(4px_*_2))] after:w-[calc(100%_+_(4px_*_2))]
        after:border-2 after:border-transparent after:transition-all after:duration-300 after:ease-in-out
        focus-visible:after:border-magenta`,
        props.isResultsPageMode
          ? `mb-5 border-none bg-transparent font-semibold ${
            props.isSelected
                ? `cursor-auto bg-deep-blue font-bold text-white before:h-0.5 before:bg-deep-blue hover:bg-deep-blue hover:text-white
                  active:bg-deep-blue active:!text-white`
                : `bg-white font-normal text-black hover:border-primary hover:bg-white hover:text-primary hover:before:h-0.5
                  hover:before:bg-deep-blue active:bg-deep-blue active:!text-white active:before:h-0.5 active:before:bg-deep-blue`
            }`
          : `bg-transparent font-semibold ${
            props.isSelected
                ? 'cursor-auto bg-deep-blue font-bold before:bg-deep-blue hover:bg-deep-blue hover:text-white active:text-white'
                : 'hover:border-primary hover:bg-deep-blue hover:text-white active:bg-deep-blue active:text-white'
            }`,
      )}
    >
      {props.label}{' '}
      {props.isResultsPageMode && (props.facetCount || props.facetCount === 0) ? `(${props.facetCount})` : ''}
    </Button>
  );
};
